
export default {
    global_alert_type: '',
    global_alert_text: '',
    global_alert: false,
    global_alert_timer: null,
    dash_cancel: false,
}

